module.exports = __webpack_public_path__ + "static/img/0403_01.dfd3af8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/04/0403_01.png
// module id = KJ5i
// module chunks = 1